import { HorizontalSortableList } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ItemCard from '../ItemCard/ItemCard';
import SelectedItem from './SelectedItem';
import SelectedItemsEmptyState from './SelectedItemsEmptyState';
import * as Ui from './SelectedItems.styles';

const SelectedItems = ({
  isLoading,
  items,
  setItems,
  getItemKey,
  isMultiple = true,
  getItemCardProps,
  onOpenModal,
  onRemove,
  onEdit,
  isEditable,
}) => {
  const { t } = useTranslation('ownerPortal', { keyPrefix: 'pageModules' });

  const handleRemove =
    onRemove ||
    ((item) => {
      const key = getItemKey(item);
      setItems(items.filter((selected) => getItemKey(selected) !== key));
    });

  const renderListItem = (item) => (
    <Ui.ItemContainer>
      <SelectedItem
        onRemove={() => handleRemove(item)}
        onEdit={onEdit && (!isEditable || isEditable(item)) ? () => onEdit(item) : undefined}
      >
        <ItemCard {...getItemCardProps(item, { t })} />
      </SelectedItem>
    </Ui.ItemContainer>
  );

  if (isLoading) {
    return (
      <Ui.LoadingState>
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
      </Ui.LoadingState>
    );
  }

  if (items.length === 0) {
    return <SelectedItemsEmptyState onClick={onOpenModal} />;
  }

  return (
    <HorizontalSortableList
      items={items}
      setItems={setItems}
      keyExtractor={getItemKey}
      disabled={!isMultiple}
      renderItem={renderListItem}
      listFooter={
        <Ui.ItemContainer>
          <Ui.FooterButton
            onClick={onOpenModal}
            aria-label={t(isMultiple ? 'addItems' : 'changeSelection')}
          >
            <i
              className={`bi ${isMultiple ? 'bi-plus-lg' : 'bi-arrow-repeat'}`}
              aria-hidden="true"
            />
          </Ui.FooterButton>
        </Ui.ItemContainer>
      }
    />
  );
};

SelectedItems.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  setItems: PropTypes.func.isRequired,
  getItemKey: PropTypes.func.isRequired,
  isMultiple: PropTypes.bool,
  getItemCardProps: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
  onEdit: PropTypes.func,
  isEditable: PropTypes.func,
};

SelectedItems.defaultProps = {
  isLoading: false,
  onRemove: undefined,
  onEdit: undefined,
  isEditable: undefined,
};

export default SelectedItems;
